import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {AppConfigService} from 'src/app-config.service';
import {GeneralService} from 'src/app/service/general-service';
import {TableSelectionAbstract} from 'src/app/shared/component/table/table-selection.abstract';
import {Constant} from '../../../../../shared/constants/constant.class';

@Component({
  selector: "app-inventory-list",
  templateUrl: "./inventory-list.component.html",
  styleUrls: ["./inventory-list.component.scss"],
})
export class InventoryListComponent
  extends TableSelectionAbstract
  implements OnInit
{
  datas: any[] = [];
  data: any;
  filterForm: FormGroup;
  pageSize: any;
  defaultPageSize: any;
  pageIndex = 1;
  total = 1;
  dataColumn: any[];
  dataColumnChecked: any[];
  loading: boolean;
  expandSet = new Set<number>();
  daysWarningChemical: number;
  amountWarningChemical: number;
  CHEMICAL_WARNING_TYPE = {
    expired: "expired",
    almostExpired: "almost-expired",
    amount: "amount",
  };
  selectedWarehouseId: any;
  constructor(
    private configService: AppConfigService,
    private fb: FormBuilder,
    private translate: TranslateService,
    private generalService: GeneralService,
    private appConfigService: AppConfigService
  ) {
    super("id");
    this.filterForm = this.fb.group({
      name: [null],
      batchCode: [null],
      amountMin: [null],
      amountMax: [null],
      expiredDateFrom: [null],
      expiredDateTo: [null],
    });
    this.amountWarningChemical =
      this.appConfigService.getConfig().amountWarningChemical;
    this.daysWarningChemical =
      this.appConfigService.getConfig().daysWarningChemical;
  }

  ngOnInit(): void {
    this.selectedWarehouseId = +localStorage.getItem(Constant.WAREHOUSE_ID);
    this.pageSize = this.configService.getConfig().pageSize;
    this.defaultPageSize = this.configService.getConfig().defaultPage;
    this.pageIndex = 1;
    this.bindDefaultColumn();
    // this.getChemicals();
    this.getListData();
    this.get();
  }

  bindDefaultColumn() {
    this.dataColumn = [
      { label: "Tên hóa chất", checked: true, name: "chemicalName" },
      { label: "Mã hóa chất", checked: true, name: "chemicalCode" },
      { label: "Quy cách đóng gói", checked: true, name: "packingType" },
      { label: "Đơn vị tính", checked: true, name: "packing" },
      { label: "Số lượng tồn", checked: true, name: "currentAmount" },
      { label: "Số lượng xuất kho", checked: true, name: "currentAmount" },
      { label: "Số lượng nhập kho", checked: true, name: "currentAmount" },
      // {label: 'Số lượng tồn theo đơn vị tiêu hao', checked: true, name: 'currentAmountByUnit'},
    ];
  }

  getListData() {
    this.dataColumnChecked = this.dataColumn.filter(
      (item) => item.checked === true
    );
    this.loading = true;
    const payload = {
      pageSize: this.defaultPageSize,
      pageNo: this.pageIndex,
      wareHouseId: this.selectedWarehouseId,
      name: "",
      batchCode: "",
      amountMin: "",
      amountMax: "",
      expiredDateFrom: "",
      expiredDateTo: "",
    };
    if (this.filterForm.value) {
      if (this.filterForm.value.name) {
        payload.name = this.filterForm.value.name;
      }
      if (this.filterForm.value.batchCode) {
        payload.batchCode = this.filterForm.value.batchCode;
      }
      if (this.filterForm.value.amountMin) {
        payload.amountMin = this.filterForm.value.amountMin;
      }
      if (this.filterForm.value.amountMax) {
        payload.amountMax = this.filterForm.value.amountMax;
      }
      if (this.filterForm.value.expiredDateFrom) {
        payload.expiredDateFrom = this.filterForm.value.expiredDateFrom;
      }
      if (this.filterForm.value.expiredDateTo) {
        payload.expiredDateTo = this.filterForm.value.expiredDateTo;
      }
    }
    console.log(payload);
    
    this.generalService.getWarehouse(payload).subscribe(
      (res) => {
        if (res !== null) {
          this.datas = res.data;
          this.total = res.total;
          this.loading = false;
          super.setListOfAllData(this.datas);
          console.log("warehouse", res);
          console.log("warehouse", res.total);
        }
      },
      (error) => {}
    );
  }

  get() {
    this.translate.use(this.translate.currentLang).subscribe((data) => {
      this.data = data;
      console.log(this.data);
    });
  }

  /*getChemicals()  {
    this.generalService.getChemical().subscribe ( res => {
      if ( res !== null) {
        this.datas = res;
        console.log("chemicals", res);
      }
    }, error => {}
    );
  }*/
  onQueryParamsChange(params): void {
    const { pageSize, pageIndex, sort, filter } = params;
    this.pageIndex = params.pageIndex;
    this.defaultPageSize = params.pageSize;
    const currentSort = sort.find((item) => item.value !== null);
    this.getListData();
  }

  doSearch() {
    this.getListData();
  }

  onExpandChange(id: number): void {
    console.log("checked", this.expandSet, id);
    if (this.expandSet.has(id)) {
      this.expandSet.delete(id);
    } else {
      this.expandSet.add(id);
    }
  }

  datatimeToDateTimeZone(datetime: Date, expiringDay: number, data: any) {
    if (datetime == null) {
      return null;
    }
    const dayOfNow = new Date().getTime();
    const date1 = new Date(datetime);
    if (!Array.isArray(data.isWarning)) {
      data.isWarning = [];
    }
    if ((date1.getTime() - dayOfNow) / 86400000 < -1) {
      data.isWarning.push(this.CHEMICAL_WARNING_TYPE.expired);
      return 2;
    }

    if (
      (date1.getTime() - dayOfNow) / 86400000 <= expiringDay &&
      (date1.getTime() - dayOfNow) / 86400000 >= -1
    ) {
      data.isWarning.push(this.CHEMICAL_WARNING_TYPE.almostExpired);
      return 1;
    } else {
      return 0;
    }
  }

  checkAmount(item: any, data: any) {
    if (!Array.isArray(data.isWarning)) {
      data.isWarning = [];
    }
    if (
      item.currentAmount <= data.chemical.inventoryAlert &&
      item.currentAmount > 0
    ) {
      data.isWarning.push(this.CHEMICAL_WARNING_TYPE.amount);
      return 0;
    }
    if (item.currentAmount === 0) {
      return 1;
    }
    if (item.currentAmount > data.chemical.inventoryAlert) {
      return 2;
    }
  }

  clearSearch() {
    this.filterForm.reset();
    this.getListData();
  }

  refreshFilter() {
    localStorage.removeItem("tableDisplay");
    this.bindDefaultColumn();
    this.getListData();
  }

  getRowIndex = (index, pageIndex, pageSize) =>
    index + 1 + pageSize * (pageIndex - 1);

  toTdValue(colName, item) {
    switch (colName) {
      case "chemicalName":
        return item.chemicalName;
      case "chemicalCode":
        return item.chemicalCode;
      case "packingType":
        if (
          item.chemical &&
          item.chemical.packingQuantity &&
          item.chemical.packingUnit &&
          item.chemical.packing
        )
          return `${item.chemical.packingQuantity} ${item.chemical.packingUnit}/${item.chemical.packing} `;
        else return "";
      case "packing":
        return item.chemical.packing;
      case "currentAmount":
        return this.numberWithCommas(item.currentAmount);
      case "currentAmountByUnit":
        return item.currentAmount * item.chemical?.packingQuantity;
      default:
        return item[colName];
    }
    return "";
  }

  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
}
